import styled, { css } from 'styled-components'
import NextImage from 'next/image'
import PulseLoader from 'react-spinners/PulseLoader'

import ScoreStar from '../ScoreStar'
import { mq, sizes } from '../../theme'
import Avatar from '../Avatar'
import ActionButton from '../ActionButton'
import Link from '../Link'
import Icon from '../Icon'

export const Feedback = styled.div<{ $isLogInAndMember?: boolean }>`
  @media ${mq(sizes.tablet)} {
    border-radius: 20px;
  }

  ${({ $isLogInAndMember }) =>
    $isLogInAndMember &&
    css`
      background-color: ${({ theme }) => theme.colors.blueBack};
      padding: 3.5rem;
    `}
`

export const Header = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.colors.greyContour};
  padding-bottom: 4.5rem;
  margin-bottom: 2rem;

  @media ${mq(null, sizes.tablet)} {
    flex-wrap: wrap;
  }
`
export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0;

  @media ${mq(null, sizes.tablet)} {
    flex-basis: 100%;
  }
`

export const NumberFeedback = styled.span`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.vujahdayLarge};
  @media ${mq(sizes.tablet)} {
    margin-left: 1rem;
  }
`

export const ScoreWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`

export const Sidebar = styled.div``

export const Actions = styled.div`
  display: flex;
  gap: 0.9rem;
  margin-top: 1rem;
`

export const Action = styled.button`
  all: unset;
`

export const StyledIcon = styled(Icon)``

export const Score = styled(ScoreStar)``

export const MemberFeedbackBlockWrapper = styled.div<{
  $isLogInAndMember: boolean
}>`
  margin: auto 0 3.5rem 0;
  ${({ $isLogInAndMember }) =>
    !$isLogInAndMember &&
    css`
      filter: blur(4px);
    `}
`

export const NoFeedbackText = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratXlMedium};
  text-align: center;
`

export const PendingFeedbackText = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratTextBaseMedium};
`

export const MemberFeedbackBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  padding: 3.2rem 0;
  border-bottom: 1px dashed #a7b1c0;
`

export const MemberAvatar = styled(Avatar)``

export const MemberNameDescriptionBlock = styled.div`
  width: 100%;
`
export const FeedbackEntryHead = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0.5rem;
  margin-bottom: 0.8rem;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 1.5rem;
    height: 1px;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #000;
  }
`
export const MemberName = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratTextBase};
  font-weight: bold;
`
export const MemberDate = styled.p`
  color: ${({ theme }) => theme.colors.taupeGray};
  ${({ theme }) => theme.textStyles.montserratXs};
`
export const MemberDescription = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
`
export const MemberScore = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratTextBase};
  font-weight: bold;
  text-align: right;
`

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.8rem;
`

export const AddOpinion = styled(ActionButton)``
export const SeeMoreOpinion = styled(Link)`
  color: ${({ theme }) => theme.colors.pinkButton};
  ${({ theme }) => theme.textStyles.montserratSm};
  font-weight: 700;
  cursor: pointer;
`

export const ImageFeedBacksTransparent = styled(NextImage)``

export const LoaderFirst = styled(PulseLoader)`
  width: max-content;
  margin: auto;
`
export const Loader = styled(PulseLoader)``
